import { createSelector } from 'reselect';

import { StoreState } from '../../../reducers';
import { EditableDataState } from '../reducer';
import { EditorType } from '../constants';

const getEditorType = (state: StoreState): EditorType => state.editor.type;
const getEditableData = (state: StoreState): EditableDataState => state.editor.configs.generalData.editablePublication;
const getCurrentSpread = (state: StoreState): number[] => state.editor.pagesController.spreads[state.editor.pagesController.currentSpreadIndex];
const isAccessibleVersion = (state: StoreState): boolean => state.editor.isAccessibleVersion;

export const isEditablePage = createSelector(
	getEditorType,
	getEditableData,
	(state: StoreState, page: number) => page,
	(editorType: EditorType, editableData: EditableDataState, page: number): boolean => (
		editorType === EditorType.HTML || Object.keys(editableData).includes(page.toString())
	),
);

export const isEditableSpread = createSelector(
	getEditableData,
	getCurrentSpread,
	getEditorType,
	isAccessibleVersion,
	(editableData: EditableDataState, currentSpread: number[], editorType: EditorType, isAccessibleVersion: boolean	): boolean => (
		editorType === EditorType.HTML ||
		isAccessibleVersion ||
		currentSpread.some(page => Object.keys(editableData).includes(page.toString()))
	),
);

export {
	getPageEditableTextFields,
	getPageEditableMedia,
	getPageEditableLinks,
	getPageEditableButtons,
	getPageEditableIframes,
	getPageEditableEnrichments,
	getPageEditableSliders,
	getPageEditableTextFieldsIds,
	getPageEditableMediaIds,
	getPageEditableLinksIds,
	getPageEditableButtonsIds,
	getPageEditableIframesIds,
	getPageEditableEnrichmentsIds,
	getPageEditableSlidersIds,
	getPageThemedItemsIds,
	EditableItem,
} from './editableItems';

export {
	getFontFamilyOptions,
	getFontSizeOptions,
	getColorOptions,
	getLineHeightOptions,
	getLetterSpacingOptions,
} from './textFieldsData';

export {
	BackgroundData,
	getSpreadBgData,
	getGeneralBgData,
	getIsTransparentPage,
} from './spreadBackground';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/selectors/index.ts